import { render, staticRenderFns } from "./PaymentErrorsList.vue?vue&type=template&id=a1028486&scoped=true&"
import script from "./PaymentErrorsList.vue?vue&type=script&lang=js&"
export * from "./PaymentErrorsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentErrorsList.vue?vue&type=style&index=0&id=a1028486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1028486",
  null
  
)

export default component.exports